export default {
    name: 'Név',
    tel: 'Telefon',
    save: 'Mentés',
    confirm: 'Megerősítés',
    cancel: 'Mégse',
    delete: 'Törlés',
    complete: 'Befejezés',
    loading: 'Betöltés...',
    telEmpty: 'Töltse ki a telefonszámot',
    nameEmpty: 'Töltse ki a nevet',
    nameInvalid: 'Hibás névformátum',
    confirmDelete: 'Biztosan törölni szeretné?',
    telInvalid: 'Érvénytelen telefonszám',
    vanCalendar: {
        end: 'Vég',
        start: 'Kezdet',
        title: 'Naptár',
        startEnd: 'Kezdet/Vég',
        weekdays: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Legfeljebb ${maxRange} napot válasszon`,
    },
    vanCascader: {
        select: 'Kiválasztás',
    },
    vanContactCard: {
        addText: 'Kapcsolattartó hozzáadása',
    },
    vanContactList: {
        addText: 'Új kapcsolat hozzáadása',
    },
    vanPagination: {
        prev: 'Előző',
        next: 'Következő',
    },
    vanPullRefresh: {
        pulling: 'Húzzon le frissítéshez...',
        loosing: 'Engedje el a frissítéshez...',
    },
    vanSubmitBar: {
        label: 'Összesen：',
    },
    vanCoupon: {
        unlimited: 'Korlátlan',
        discount: (discount) => `${discount * 10}% kedvezmény`,
        condition: (condition) => `Legalább ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupon',
        tips: 'Nincsenek kupongok',
        count: (count) => `Önnek ${count} kupongja van`,
    },
    vanCouponList: {
        empty: 'Nincsenek kupongok',
        exchange: 'Beváltás',
        close: 'Bezárás',
        enable: 'Elérhető',
        disabled: 'Nem elérhető',
        placeholder: 'Kuponkód',
    },
    vanAddressEdit: {
        area: 'Terület',
        postal: 'Irányítószám',
        areaEmpty: 'Válassza ki a kézbesítési területet',
        addressEmpty: 'A cím nem lehet üres',
        postalEmpty: 'Érvénytelen irányítószám',
        defaultAddress: 'Beállítás alapértelmezett címként',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Név',
        areaPlaceholder: 'Terület',
    },
    vanAddressEditDetail: {
        label: 'Cím',
        placeholder: 'Cím',
    },
    vanAddressList: {
        add: 'Új cím hozzáadása',
    },
};